import { STATIC_ASSETS_PLACEHOLDER } from "../staticAssetsPlaceholder.js";
export const birthdayBalloons = {
    version: 1,
    themeId: "birthday-balloons",
    name: "Birthday Balloons",
    endFadeDuration: 1,
    thumbnailFrame: 160,
    thumbnailUrl: `${STATIC_ASSETS_PLACEHOLDER}/compilations/theme-stills/birthday-balloons.webp`,
    background: [
        {
            variant: "confetti",
            background: "#FBF7EC",
            colors: ["#C7AD85", "#A97583", "#B66262", "#A29B7E", "#BDA74F"],
            count: 20,
        },
    ],
    scenes: [
        {
            type: "lottie",
            lottieUrl: `${STATIC_ASSETS_PLACEHOLDER}/compilations/themes/birthday-balloons/intro_banner.json`,
            durationSeconds: 8,
            exitTransition: {
                variant: "fadeOutScaleIn",
                timing: {
                    variant: "spring",
                    config: { mass: 1.75, stiffness: 50, damping: 12 },
                    durationSeconds: 1,
                },
            },
        },
        {
            type: "greeting",
            variant: "intro",
            secondsPerCharacter: 0.05,
            minimumMessageDisplayTimeSeconds: 2,
            showLogo: true,
            betweenMessageTransition: {
                variant: "scale",
                enterDurationSeconds: 0.33333,
                exitDurationSeconds: 0.16666,
            },
            sceneBackground: {
                variant: "bunting",
                buntingUrls: [
                    {
                        full: `${STATIC_ASSETS_PLACEHOLDER}/compilations/themes/birthday-balloons/bunting.webp`,
                        preview: `${STATIC_ASSETS_PLACEHOLDER}/compilations/themes/birthday-balloons/optimized/bunting.webp`,
                    },
                ],
                starsUrls: [
                    {
                        full: `${STATIC_ASSETS_PLACEHOLDER}/compilations/themes/birthday-balloons/star1.webp`,
                        preview: `${STATIC_ASSETS_PLACEHOLDER}/compilations/themes/birthday-balloons/optimized/star1.webp`,
                    },
                    {
                        full: `${STATIC_ASSETS_PLACEHOLDER}/compilations/themes/birthday-balloons/star2.png`,
                        preview: `${STATIC_ASSETS_PLACEHOLDER}/compilations/themes/birthday-balloons/optimized/star2.webp`,
                    },
                    {
                        full: `${STATIC_ASSETS_PLACEHOLDER}/compilations/themes/birthday-balloons/star3.png`,
                        preview: `${STATIC_ASSETS_PLACEHOLDER}/compilations/themes/birthday-balloons/optimized/star3.png`,
                    },
                ],
            },
        },
        {
            type: "clip-series-basic",
            showLogo: true,
            sceneBackground: {
                variant: "bunting",
                buntingUrls: [
                    {
                        full: `${STATIC_ASSETS_PLACEHOLDER}/compilations/themes/birthday-balloons/bunting.webp`,
                        preview: `${STATIC_ASSETS_PLACEHOLDER}/compilations/themes/birthday-balloons/optimized/bunting.webp`,
                    },
                ],
                starsUrls: [
                    {
                        full: `${STATIC_ASSETS_PLACEHOLDER}/compilations/themes/birthday-balloons/star1.webp`,
                        preview: `${STATIC_ASSETS_PLACEHOLDER}/compilations/themes/birthday-balloons/optimized/star1.webp`,
                    },
                    {
                        full: `${STATIC_ASSETS_PLACEHOLDER}/compilations/themes/birthday-balloons/star2.png`,
                        preview: `${STATIC_ASSETS_PLACEHOLDER}/compilations/themes/birthday-balloons/optimized/star2.webp`,
                    },
                    {
                        full: `${STATIC_ASSETS_PLACEHOLDER}/compilations/themes/birthday-balloons/star3.png`,
                        preview: `${STATIC_ASSETS_PLACEHOLDER}/compilations/themes/birthday-balloons/optimized/star3.png`,
                    },
                ],
            },
        },
        {
            type: "greeting",
            variant: "outro",
            secondsPerCharacter: 0.05,
            minimumMessageDisplayTimeSeconds: 2,
            showLogo: true,
            sceneBackground: {
                variant: "bunting",
                buntingUrls: [
                    {
                        full: `${STATIC_ASSETS_PLACEHOLDER}/compilations/themes/birthday-balloons/bunting.webp`,
                        preview: `${STATIC_ASSETS_PLACEHOLDER}/compilations/themes/birthday-balloons/optimized/bunting.webp`,
                    },
                ],
                starsUrls: [
                    {
                        full: `${STATIC_ASSETS_PLACEHOLDER}/compilations/themes/birthday-balloons/star1.webp`,
                        preview: `${STATIC_ASSETS_PLACEHOLDER}/compilations/themes/birthday-balloons/optimized/star1.webp`,
                    },
                    {
                        full: `${STATIC_ASSETS_PLACEHOLDER}/compilations/themes/birthday-balloons/star2.png`,
                        preview: `${STATIC_ASSETS_PLACEHOLDER}/compilations/themes/birthday-balloons/optimized/star2.webp`,
                    },
                    {
                        full: `${STATIC_ASSETS_PLACEHOLDER}/compilations/themes/birthday-balloons/star3.png`,
                        preview: `${STATIC_ASSETS_PLACEHOLDER}/compilations/themes/birthday-balloons/optimized/star3.png`,
                    },
                ],
            },
        },
        {
            type: "outro",
            colorVariant: "darkBlue",
            entranceVariant: "slide-in-fade-in",
        },
    ],
    styles: {
        textBox: {
            backgroundColor: "#fff",
            backgroundOpacity: 0,
            backgroundBlur: 2,
            textAlign: "center",
            textColor: "#333",
            fontFamily: "Poiret One",
            fontWeight: "bold",
            fontSize: 96,
            leading: 1.1,
            tracking: 0.05,
            backdropCustom: {
                "box-shadow": "none",
            },
        },
        clips: {
            betweenTransition: {
                variant: "scale",
                timing: {
                    variant: "spring",
                    config: { mass: 1.75, stiffness: 50, damping: 12 },
                    durationSeconds: 1,
                },
            },
            textVariant: { variant: "default" },
            title: {
                backgroundColor: "#fff",
                backgroundOpacity: 0.95,
                textColor: "#3f3f46",
                fontFamily: "Futura",
                fontWeight: "medium",
                fontSize: 80,
                nudge: 2,
                textTransform: "none",
            },
            subtitle: {
                backgroundColor: "#3f3f46",
                backgroundOpacity: 0.95,
                textColor: "#fff",
                fontFamily: "Futura",
                fontWeight: "medium",
                fontSize: 48,
                nudge: 2,
                textTransform: "none",
            },
            borderRadius: "2rem",
            border: "solid 0.75rem #555658",
        },
        watermark: {
            opacity: 0.8,
            margin: 32,
            enterTransition: {
                variant: "slide",
                direction: "from-right",
                timing: { variant: "linear", durationSeconds: 1 },
            },
            exitTransition: {
                variant: "slide",
                direction: "from-right",
                timing: { variant: "linear", durationSeconds: 1 },
            },
        },
        sceneTransition: {
            variant: "scale",
            timing: {
                variant: "spring",
                config: { mass: 1.75, stiffness: 50, damping: 12 },
                durationSeconds: 1,
            },
        },
    },
};
